/* GENERADO — no editar a mano.
   Capitales de las 52 provincias españolas, para situar cualquier código postal.
   La clave son los DOS PRIMEROS DÍGITOS del CP, que en España son el código INE
   de provincia (28=Madrid, 29=Málaga, 03=Alicante, 51=Ceuta...).
   Se usa la capital y no el centro geométrico porque para ordenar por cercanía
   importa dónde está la gente, no dónde está el centro del polígono.
   Fuente: Nominatim/OpenStreetMap, generado el 28-ago-2026. Verificado contra
   distancias conocidas: Madrid-Barcelona 506 km, Madrid-Sevilla 391 km. */
window.NDK_PROVINCIAS = {
  "01": [42.8506, -2.6614, "Vitoria-Gasteiz"],
  "02": [38.9951, -1.8559, "Albacete"],
  "03": [38.3436, -0.4882, "Alicante"],
  "04": [36.8686, -2.312, "Almería"],
  "05": [40.6572, -4.6627, "Ávila"],
  "06": [38.8782, -6.9701, "Badajoz"],
  "07": [39.5696, 2.6501, "Palma de Mallorca"],
  "08": [41.3826, 2.1771, "Barcelona"],
  "09": [42.3448, -3.6812, "Burgos"],
  "10": [39.4745, -6.3717, "Cáceres"],
  "11": [36.5297, -6.2929, "Cádiz"],
  "12": [39.986, -0.0377, "Castellón de la Plana"],
  "13": [38.9597, -3.8829, "Ciudad Real"],
  "14": [37.8846, -4.776, "Córdoba"],
  "15": [43.3466, -8.4127, "A Coruña"],
  "16": [40.0661, -2.1314, "Cuenca"],
  "17": [41.9793, 2.8199, "Girona"],
  "18": [37.1735, -3.5995, "Granada"],
  "19": [40.74, -2.5059, "Guadalajara"],
  "20": [43.3224, -1.9839, "San Sebastián"],
  "21": [37.2576, -6.9485, "Huelva"],
  "22": [42.1361, -0.0298, "Huesca"],
  "23": [37.7729, -3.7883, "Jaén"],
  "24": [42.6341, -5.9714, "León"],
  "25": [41.6148, 0.6268, "Lleida"],
  "26": [42.4661, -2.4397, "Logroño"],
  "27": [43.0395, -7.4568, "Lugo"],
  "28": [40.4168, -3.7035, "Madrid"],
  "29": [36.7648, -4.4422, "Málaga"],
  "30": [37.9348, -1.1131, "Murcia"],
  "31": [42.8157, -1.6522, "Pamplona"],
  "32": [42.194, -7.5371, "Ourense"],
  "33": [43.3533, -5.8795, "Oviedo"],
  "34": [42.4096, -4.6161, "Palencia"],
  "35": [28.1289, -15.4349, "Las Palmas de Gran Canaria"],
  "36": [42.4281, -8.6041, "Pontevedra"],
  "37": [40.9652, -5.664, "Salamanca"],
  "38": [28.4672, -16.2508, "Santa Cruz de Tenerife"],
  "39": [43.4619, -3.81, "Santander"],
  "40": [40.9481, -4.1172, "Segovia"],
  "41": [37.3886, -5.9953, "Sevilla"],
  "42": [41.6013, -2.7219, "Soria"],
  "43": [41.1172, 1.2546, "Tarragona"],
  "44": [40.6005, -0.9229, "Teruel"],
  "45": [39.8559, -4.0243, "Toledo"],
  "46": [39.4697, -0.3763, "Valencia"],
  "47": [41.62, -4.726, "Valladolid"],
  "48": [43.263, -2.935, "Bilbao"],
  "49": [41.6858, -5.9423, "Zamora"],
  "50": [41.6916, -0.9101, "Zaragoza"],
  "51": [35.8944, -5.3558, "Ceuta"],
  "52": [35.2919, -2.9409, "Melilla"],
};
